module.exports = "<areas-form [area]=land title=\"Add New Area\" [onSubmit]=\"submit.bind(this)\" key=\"add\"></areas-form>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/components/areas/add/add.component.html
// module id = ../../../../../src/app/components/areas/add/add.component.html
// module chunks = main